/* CAPRIMAFFIA — TERRACE v2
   Statement, lookbook, parallax, cursor y transición de página.
   JS vanilla, sin dependencias externas. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function reduced() {
    return reduce.matches;
  }

  /* ----------------------------------------------------------------------
     1. Statement — revela el titular palabra a palabra
     ---------------------------------------------------------------------- */
  function initStatement(root) {
    root.querySelectorAll('.cm-statement:not([data-cm-ready])').forEach(function (section) {
      section.setAttribute('data-cm-ready', 'true');

      var target = section.querySelector('.cm-statement__text');
      if (!target) return;

      if (reduced() || !('IntersectionObserver' in window)) {
        section.classList.add('is-in');
        return;
      }

      // Parte el texto en palabras conservando el contenido original
      var words = target.textContent.trim().split(/\s+/);
      var step = parseInt(section.dataset.cmStep || '60', 10);
      target.textContent = '';

      words.forEach(function (word, i) {
        var outer = document.createElement('span');
        outer.className = 'cm-word';

        var inner = document.createElement('span');
        inner.textContent = word;
        inner.style.setProperty('--cm-word-delay', i * step + 'ms');

        outer.appendChild(inner);
        target.appendChild(outer);

        if (i < words.length - 1) target.appendChild(document.createTextNode(' '));
      });

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            section.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0.2 }
      );

      io.observe(section);
    });
  }

  /* ----------------------------------------------------------------------
     2. Lookbook — avance horizontal atado al scroll vertical
     ---------------------------------------------------------------------- */
  function initLookbook(root) {
    root.querySelectorAll('.cm-look:not([data-cm-ready])').forEach(function (section) {
      section.setAttribute('data-cm-ready', 'true');

      var pin = section.querySelector('.cm-look__pin');
      var rail = section.querySelector('.cm-look__rail');
      if (!pin || !rail) return;

      // En móvil y con movimiento reducido, galería normal con swipe.
      // El scroll-jacking en táctil rinde mal y se pelea con el gesto del sistema.
      function isStatic() {
        return reduced() || window.innerWidth < 750;
      }

      var distance = 0;

      function measure() {
        if (isStatic()) {
          section.classList.add('is-static');
          section.style.height = '';
          rail.style.transform = '';
          return;
        }

        section.classList.remove('is-static');
        distance = Math.max(0, rail.scrollWidth - window.innerWidth);
        // La sección se hace tan alta como recorrido horizontal haya que cubrir
        section.style.height = window.innerHeight + distance + 'px';
        update();
      }

      function update() {
        if (isStatic() || !distance) return;

        var rect = section.getBoundingClientRect();
        var progress = Math.min(Math.max(-rect.top / distance, 0), 1);
        rail.style.transform = 'translate3d(' + -(progress * distance) + 'px, 0, 0)';
      }

      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update();
            ticking = false;
          });
        },
        { passive: true }
      );

      var timer;
      window.addEventListener('resize', function () {
        clearTimeout(timer);
        timer = setTimeout(measure, 150);
      });

      // Las imágenes cambian el ancho del raíl al cargar
      window.addEventListener('load', measure);
      measure();
    });
  }

  /* ----------------------------------------------------------------------
     3. Parallax — la imagen se desplaza más lento que el scroll
     ---------------------------------------------------------------------- */
  function initParallax(root) {
    var nodes = root.querySelectorAll('.cm-parallax:not([data-cm-ready])');
    if (!nodes.length) return;

    var items = [];

    nodes.forEach(function (node) {
      node.setAttribute('data-cm-ready', 'true');
      if (reduced()) return;
      items.push({
        el: node,
        depth: parseFloat(node.dataset.cmDepth || '0.12'),
        visible: false,
      });
    });

    if (!items.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            items.forEach(function (item) {
              if (item.el === entry.target) item.visible = entry.isIntersecting;
            });
          });
        },
        { rootMargin: '10% 0px' }
      );
      items.forEach(function (item) {
        io.observe(item.el);
      });
    } else {
      items.forEach(function (item) {
        item.visible = true;
      });
    }

    var ticking = false;

    function update() {
      var vh = window.innerHeight;

      items.forEach(function (item) {
        if (!item.visible) return;
        var rect = item.el.getBoundingClientRect();
        // -1 arriba del viewport, +1 abajo
        var center = (rect.top + rect.height / 2 - vh / 2) / vh;
        var shift = center * item.depth * rect.height;
        item.el.style.setProperty('--cm-shift', shift.toFixed(1) + 'px');
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    update();
  }

  /* ----------------------------------------------------------------------
     4. Cursor de arrastre en carruseles
     ---------------------------------------------------------------------- */
  var cursorEl = null;

  function initCursor(root) {
    var zones = root.querySelectorAll('[data-cm-cursor]:not([data-cm-cursor-ready])');
    if (!zones.length) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (reduced()) return;

    if (!cursorEl) {
      cursorEl = document.createElement('div');
      cursorEl.className = 'cm-cursor';
      cursorEl.setAttribute('aria-hidden', 'true');
      document.body.appendChild(cursorEl);
    }

    zones.forEach(function (zone) {
      zone.setAttribute('data-cm-cursor-ready', 'true');
      var label = zone.getAttribute('data-cm-cursor') || 'ARRASTRA';

      zone.addEventListener('pointerenter', function () {
        cursorEl.textContent = label;
        cursorEl.classList.add('is-on');
      });

      zone.addEventListener('pointerleave', function () {
        cursorEl.classList.remove('is-on');
      });

      zone.addEventListener(
        'pointermove',
        function (event) {
          cursorEl.style.transform =
            'translate3d(' + event.clientX + 'px, ' + event.clientY + 'px, 0) translate(-50%, -50%) scale(1)';
        },
        { passive: true }
      );
    });
  }

  /* ----------------------------------------------------------------------
     5. Transición de página — fade corto al navegar
     ---------------------------------------------------------------------- */
  function initPageFade() {
    if (document.body.hasAttribute('data-cm-fade-ready')) return;
    if (!document.body.classList.contains('cm-page-fade')) return;
    document.body.setAttribute('data-cm-fade-ready', 'true');
    if (reduced()) return;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;

      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (link.hostname && link.hostname !== window.location.hostname) return;
      // El carrito y la cuenta abren paneles, no navegan
      if (link.closest('cart-drawer-component, .cm-header__col--right')) return;

      event.preventDefault();
      document.body.classList.add('cm-leaving');
      window.setTimeout(function () {
        window.location.href = link.href;
      }, 190);
    });

    // Volver atrás desde la caché no debe dejar la página en blanco
    window.addEventListener('pageshow', function () {
      document.body.classList.remove('cm-leaving');
    });
  }

  /* ----------------------------------------------------------------------
     6. Hero con varias campañas
     ---------------------------------------------------------------------- */
  function initHeroSlides(root) {
    root.querySelectorAll('.cm-hero--multi:not([data-cm-slides-ready])').forEach(function (hero) {
      hero.setAttribute('data-cm-slides-ready', 'true');

      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-cm-slide]'));
      if (slides.length < 2) return;

      var prev = hero.querySelector('[data-cm-hero-prev]');
      var next = hero.querySelector('[data-cm-hero-next]');
      var readout = hero.querySelector('[data-cm-hero-now]');
      var index = 0;
      var timer = null;

      function show(i) {
        index = (i + slides.length) % slides.length;

        slides.forEach(function (slide, n) {
          var on = n === index;
          slide.classList.toggle('is-current', on);
          if (on) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });

        if (readout) readout.textContent = ('0' + (index + 1)).slice(-2);
      }

      function start() {
        var speed = parseInt(hero.dataset.cmAutoplay || '0', 10);
        if (!speed || reduced()) return;
        stop();
        timer = window.setInterval(function () {
          show(index + 1);
        }, speed * 1000);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          show(index - 1);
          start();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
          start();
        });
      }

      hero.addEventListener('pointerenter', stop);
      hero.addEventListener('pointerleave', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      // Swipe en táctil
      var startX = null;
      hero.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );
      hero.addEventListener(
        'touchend',
        function (e) {
          if (startX === null) return;
          var delta = e.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 45) show(delta < 0 ? index + 1 : index - 1);
          startX = null;
        },
        { passive: true }
      );

      show(0);
      start();
    });
  }

  /* ----------------------------------------------------------------------
     7. Barra de compra pegajosa
     ---------------------------------------------------------------------- */
  function initBuyBar(root) {
    var bar = root.querySelector('[data-cm-buybar]:not([data-cm-ready])');
    if (!bar) return;
    bar.setAttribute('data-cm-ready', 'true');

    var real = document.querySelector('.add-to-cart-button');
    if (!real) return;

    bar.hidden = false;

    var cta = bar.querySelector('[data-cm-buybar-add]');
    var price = bar.querySelector('[data-cm-buybar-price]');

    // El botón de la barra no reimplementa nada: pulsa el del tema.
    // Así la variante, la cantidad y el estado de agotado siguen siendo los suyos.
    if (cta) {
      cta.addEventListener('click', function () {
        var live = document.querySelector('.add-to-cart-button');
        if (live) live.click();
      });
    }

    function syncState() {
      var live = document.querySelector('.add-to-cart-button');
      if (!live || !cta) return;
      var off = live.hasAttribute('disabled') || live.getAttribute('aria-disabled') === 'true';
      cta.disabled = off;
      cta.setAttribute('aria-disabled', off ? 'true' : 'false');

      // El precio cambia al cambiar de variante
      var livePrice = document.querySelector('.product-details .price');
      if (livePrice && price) price.innerHTML = livePrice.innerHTML;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var on = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-on', on);
            // Deja hueco al final de la página para que no tape el footer
            document.body.classList.toggle('cm-buybar-on', on);
          });
        },
        { rootMargin: '0px 0px -20% 0px' }
      );
      io.observe(real);
    }

    // El tema re-renderiza el bloque de compra al cambiar de variante
    if ('MutationObserver' in window) {
      var host = real.closest('.product-details') || document.body;
      var mo = new MutationObserver(function () {
        syncState();
      });
      mo.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    syncState();
  }

  /* ----------------------------------------------------------------------
     Arranque
     ---------------------------------------------------------------------- */
  function boot(root) {
    var scope = root || document;
    initBuyBar(scope);
    initHeroSlides(scope);
    initStatement(scope);
    initLookbook(scope);
    initParallax(scope);
    initCursor(scope);
    initPageFade();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
